import axios from "axios";
import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { TokenContext } from "../context/TokenContext";
import config from "../config";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const afasPoster = async (path: string, { arg }: { arg: { token: string; body: any } }) => {
  console.log({ arg });
  console.log("before destructuring");
  const { token, body } = arg;
  console.log("the body of the request");
  console.log({ body });
  return axios
    .post(`${config.BASE_URL}${path}`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
    .then((res) => res.data);
};

function useAfasDataMutation(path: string) {
  const token = useContext(TokenContext);
  // eslint-disable-next-line no-unused-vars
  const { trigger, isMutating, error, data } = useSWRMutation(path ? path : null, afasPoster, {});

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function doTrigger(body: any) {
    return trigger({ token: token, body: body });
  }

  return {
    trigger: doTrigger,
    data,
    isMutating,
    error,
  };
}

export default useAfasDataMutation;
